import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=0ffad59c&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=0ffad59c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffad59c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffad59c')) {
      api.createRecord('0ffad59c', component.options)
    } else {
      api.reload('0ffad59c', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=0ffad59c&scoped=true", function () {
      api.rerender('0ffad59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/islamicFinance/offerToSell/Create.vue"
export default component.exports